import { useEffect, useRef, useState } from "react";
import { usePageContext } from "@/lib/brand";
import { ChatPanel } from "@/components/chat/ChatPanel";
import { CeresMark } from "@/components/ceres/CeresMark";
import { demo } from "@/lib/demo";

export const ChatWidget = () => {
  const page = usePageContext();
  const [open, setOpen] = useState(false);
  const launcherRef = useRef(null);
  const [command, setCommand] = useState(null);

  // Presenter mode can open the panel and hand it a prompt, the Fund Finder or voice mode.
  useEffect(() => {
    const pick = () => {
      const cmd = demo.take();
      if (!cmd) return;
      setOpen(true);
      setCommand(cmd);
    };
    pick();
    return demo.subscribe(pick);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && close();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const close = () => {
    setOpen(false);
    setTimeout(() => launcherRef.current?.focus(), 0);
  };

  const expandUrl = () => {
    const q = new URLSearchParams({ from: page.path, brand: page.brand, expand: "1" });
    if (page.ticker) q.set("ticker", page.ticker);
    return `/chat?${q.toString()}`;
  };

  return (
    <>
      {open && (
        <div role="dialog" aria-modal="false" aria-labelledby="chat-title" data-testid="chat-widget-panel"
          className="ceres-panel-in fixed inset-0 z-50 flex flex-col bg-white shadow-[0_20px_60px_rgba(17,26,50,0.35)] sm:inset-auto sm:bottom-6 sm:right-6 sm:h-[min(700px,calc(100vh-48px))] sm:w-[400px] sm:border sm:border-hv-rule">
          <ChatPanel page={page} theme={page.theme} onClose={close} expandTo={expandUrl()} command={command} />
        </div>
      )}
      {!open && (
        <button ref={launcherRef} type="button" onClick={() => setOpen(true)} data-testid="chat-launcher-button" aria-label="Ask Ceres, opens the Ceres assistant" aria-expanded={open}
          className="group fixed bottom-6 right-6 z-40 flex items-center gap-3 border-2 border-white bg-hv-navy py-2.5 pl-2.5 pr-5 font-heading text-[13px] font-semibold uppercase tracking-[0.12em] text-white shadow-[0_10px_28px_rgba(17,26,50,0.35)] transition-transform duration-200 hover:-translate-y-0.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-hv-mark transition-transform duration-500 group-hover:rotate-[20deg]">
            <CeresMark size={30} tone="dark" />
          </span>
          Ask Ceres
          <span className="h-2 w-2 rounded-full hv-accent-bg" aria-hidden="true" />
        </button>
      )}
    </>
  );
};
